// src/components/navigation/PublicNav.tsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  AppBar, Toolbar, Button, Box, Divider, Typography,
  IconButton, Drawer, List, ListItem, ListItemButton, ListItemText,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import ShowrunnrLogo from '../ShowrunnrLogo';

const NAV_LINKS = [
  { label: 'Artists', to: '/bands' },
  { label: 'Strands', to: '/publicstrands' },
];

const PublicNav: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <AppBar position="static" color="primary">
        <Toolbar sx={{ justifyContent: 'space-between' }}>
{/* Logo group */}
<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
  {/* IMC Logo → external link */}
  <Box
    component="a"
    href="https://www.improvisedmusic.ie"
    target="_blank"
    rel="noopener noreferrer"
    sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
  >
    <Box
      component="img"
      src="/imc-logo.png"
      alt="IMC"
      sx={{ height: 44, width: 'auto', display: 'block' }}
    />
  </Box>

  <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(255,255,255,0.3)', my: 1 }} />

  {/* Showrunnr Logo → internal link */}
  <Box component={Link} to="/bands" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', textDecoration: 'none' }}>
    <ShowrunnrLogo width={120} height={28} clickable={false} />
    <Typography
      variant="caption"
      sx={{
        color: 'rgba(255,255,255,0.6)',
        lineHeight: 1.2,
        fontSize: '0.65rem',
        letterSpacing: '0.05em'
      }}
    >
      an initiative of IMC
    </Typography>
  </Box>
</Box>

          {/* Desktop nav — hidden on mobile */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 1 }}>
            {NAV_LINKS.map(({ label, to }) => (
              <Button key={to} color="inherit" component={Link} to={to}>{label}</Button>
            ))}
            <Button
              variant="outlined"
              color="inherit"
              component={Link}
              to="/login"
              size="small"
              sx={{ borderColor: 'rgba(255,255,255,0.5)', ml: 1 }}
            >
              Login
            </Button>
          </Box>

          {/* Hamburger — visible on mobile only */}
          <IconButton
            color="inherit"
            edge="end"
            onClick={() => setDrawerOpen(true)}
            sx={{ display: { xs: 'flex', md: 'none' } }}
            aria-label="Open menu"
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{ sx: { width: 240, bgcolor: 'background.paper' } }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', px: 2, py: 1.5 }}>
          <IconButton onClick={() => setDrawerOpen(false)} aria-label="Close menu">
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />
        <List disablePadding>
          {NAV_LINKS.map(({ label, to }) => (
            <ListItem key={to} disablePadding>
              <ListItemButton
                component={Link}
                to={to}
                onClick={() => setDrawerOpen(false)}
                sx={{ py: 1.5, px: 3 }}
              >
                <ListItemText primary={label} primaryTypographyProps={{ fontWeight: 600, fontSize: '1rem' }} />
              </ListItemButton>
            </ListItem>
          ))}
          <Divider sx={{ my: 1 }} />
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/login"
              onClick={() => setDrawerOpen(false)}
              sx={{ py: 1.5, px: 3 }}
            >
              <ListItemText primary="Login" primaryTypographyProps={{ fontWeight: 600, fontSize: '1rem', color: 'primary.main' }} />
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>
    </>
  );
};

export default PublicNav;
